module.exports = __webpack_public_path__ + "static/img/慢速1.4a0ed8cc.png";